<template>
  <div class="section">
    <div v-if="isMaxScreen" class="page pc_page-2">
      <div class="page-2-content-container">
        <div class="step-text-container">{{$t('components.section2.646tj9dnkk00')}}</div>
        <div class="step-container">
          <div
            v-for="step in steps"
            :key="step.id"
            :class="['step-item', { 'cur-step': curStep == step.id }]"
            @mouseenter="handleMouseenter(step.id)"
            @mouseleave="handleMouseleave(step.id)"
          >
            <img
              :src="curStep == step.id ? step.checkedIcon : step.uncheckedIcon"
              alt=""
              class="step-icon"
            />
            {{ step.name }}
          </div>
        </div>
        <div class="step-image-conteiner">
          <img
            :src="isES ? steps[curStep - 1].esPcImage : steps[curStep - 1].enPcImage"
            alt=""
            class="step-image"
          />
        </div>
      </div>
    </div>

    <div v-else class="page page-2">
      <div class="step-container">
        <div
          v-for="step in steps"
          :key="step.id"
          :class="['step-item', { 'cur-step': curStep == step.id }]"
          @click="handleStep(step.id)"
        >
          <img
            :src="curStep == step.id ? step.checkedIcon : step.uncheckedIcon"
            alt=""
            class="step-icon"
          />
        </div>
      </div>
      <div class="step-name-text-container">
      <div class="step-name">{{ steps[curStep - 1].name }}</div>
      <div class="step-text">{{ steps[curStep - 1].text }}</div>
      </div>
      <div class="step-image-conteiner">
        <img
          :src="steps[curStep - 1].mbImage"
          alt=""
          class="step-image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
export default {
  name: 'section2',
  components: {},
  data() {
    return {
      isES,
      curStep: 1,
      steps: [
        {
          id: 1,
          step: 1,
          name: this.$t('components.section2.s1'),
          text: this.$t('components.section2.s1t'),
          checkedIcon: require('../../../assets/image/eu-home/icon/Progress_checked_1.png'),
          uncheckedIcon: require('../../../assets/image/eu-home/icon/Progress_Unchecked_1.png'),
          esPcImage: require('../../../assets/image/eu-home/es-pc-step-1.png'),
          enPcImage: require('../../../assets/image/eu-home/en-pc-step-1.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-1.png')
        },
        {
          id: 2,
          step: 2,
          name: this.$t('components.section2.s2'),
          text: this.$t('components.section2.s2t'),
          checkedIcon: require('../../../assets/image/eu-home/icon/Progress_checked_2.png'),
          uncheckedIcon: require('../../../assets/image/eu-home/icon/Progress_Unchecked_2.png'),
          esPcImage: require('../../../assets/image/eu-home/es-pc-step-2.png'),
          enPcImage: require('../../../assets/image/eu-home/en-pc-step-2.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-2.png')
        },
        {
          id: 3,
          step: 3,
          name: this.$t('components.section2.s3'),
          text: this.$t('components.section2.s3t'),
          checkedIcon: require('../../../assets/image/eu-home/icon/Progress_checked_3.png'),
          uncheckedIcon: require('../../../assets/image/eu-home/icon/Progress_Unchecked_3.png'),
          esPcImage: require('../../../assets/image/eu-home/es-pc-step-3.png'),
          enPcImage: require('../../../assets/image/eu-home/en-pc-step-3.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-3.png')
        },
        {
          id: 4,
          step: 4,
          name: this.$t('components.section2.s4'),
          text: this.$t('components.section2.s4t'),
          checkedIcon: require('../../../assets/image/eu-home/icon/Progress_checked_4.png'),
          uncheckedIcon: require('../../../assets/image/eu-home/icon/Progress_Unchecked_4.png'),
          esPcImage: require('../../../assets/image/eu-home/es-pc-step-4.png'),
          enPcImage: require('../../../assets/image/eu-home/en-pc-step-4.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-4.png')
        }
      ]
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  methods: {
    handleStep(step) {
      this.curStep = step;
    },
    handleMouseenter(step) {
      this.curStep = step;
    },
    handleMouseleave(step) {}
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .pc_page-2 {
      background: #fff;
      padding-bottom: 80px;
      .page-2-content-container{
        max-width: 1400px;
        margin: auto;
        .step-text-container {
          width: 100%;
          color: #252629;
          font-family: 'PingFang SC';
          font-size: 64px;
          font-style: normal;
          font-weight: 500;
          line-height: 150%;
          margin: 40px 0;
        }
        .step-container {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .step-item {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 24px 32px;
            color: #8f949d;
            font-family: 'PingFang SC';
            font-size: 24px;
            font-weight: 400;
            cursor: pointer;
            position: relative;
            gap: 16px;
            &.cur-step {
              color: #252629;
              font-weight: 600;
              &::after {
                content: '';
                display: block;
                height: 4px;
                width: 100%;
                background: #252629;
                position: absolute;
                bottom: 0;
              }
            }
  
            .step-icon {
              width: 36px;
              height: 36px;
            }
          }
        }
        .step-image-conteiner {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .step-image {
            width: 100%;
          }
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .page-2 {
      background: #fff;
      padding: 120px 0;
      .step-container {
        width: calc(100% - 60px);
        display: flex;
        align-items: center;
        padding: 0 0 40px 60px;
        gap: 40px;
        .step-item {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #8f949d;
          font-family: 'PingFang SC';
          font-size: 28px;
          font-weight: 400;
          cursor: pointer;
          position: relative;
          gap: 14px;
          &.cur-step {
            color: #252629;
            font-weight: 600;
          }

          .step-icon {
            width: 64px;
            height: 64px;
          }
        }
      }
      .step-name-text-container{
        width: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left: 60px;
        .step-name{
          width: 100%;
          color: #333;
          font-family: Poppins;
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-bottom: 12px;
        }
        .step-text{
          width: 100%;
          color:  #8F949D;
          font-family: Poppins;
          font-size: 32px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

      }
      .step-image-conteiner {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .step-image {
          width: 100%;
        }
      }
    }
  }
}
</style>
